export function Footer() {
  return (
    <footer className="wrap site-footer">
      <a href="/">Home</a>
      <a href="/privacy">Privacy</a>
      <a href="/terms">Terms</a>
      <span className="copy">© 2026 calendarfeedback.com</span>
    </footer>
  )
}
